import * as Styled from './RadioTab.styled';
import { forwardRef } from 'react';
import RadioTabOption from './RadioTabOption';
import { RadioTabProps } from './RadioTab.types';

export const RadioTab = forwardRef<HTMLDivElement, RadioTabProps>(
  (
    {
      name,
      disabled = false,
      required = false,
      hasError = false,
      options,
      selectedOption,
      onChange,
    },
    ref,
  ) => {
    const totalOfRadioTabOptions = options.length;
    const hasSelectedValue = selectedOption && selectedOption.value;
    const selectedIndex =
      options &&
      hasSelectedValue &&
      options.findIndex((option) => option.value === selectedOption.value);

    return (
      <Styled.RadioTab ref={ref} hasError={hasError} disabled={disabled}>
        {totalOfRadioTabOptions > 0 &&
          options.map((option) => {
            const isChecked =
              !disabled &&
              !hasError &&
              selectedOption &&
              selectedOption.value === option.value;

            return (
              <RadioTabOption
                name={name}
                key={option.value}
                checked={isChecked}
                value={option.value}
                text={option.displayText}
                onChange={onChange}
                required={required}
                hasError={hasError}
                disabled={disabled}
              />
            );
          })}
        {!hasError &&
          totalOfRadioTabOptions > 0 &&
          typeof selectedIndex === 'number' && (
            <Styled.RadioTabChecked
              disabled={disabled}
              index={selectedIndex}
              total={totalOfRadioTabOptions}
            />
          )}
      </Styled.RadioTab>
    );
  },
);

RadioTab.displayName = 'RadioTab';

export default RadioTab;
